import { TDocument } from '../../apis/documents/documents.interfaces';
import {
  TDocumentStatus,
  TDocumentType,
} from '../../apis/documents/documents.interfaces';
import { mockUserAction } from '../users/userAction';

export const mockDocument: TDocument = {
  documentId: 'doc123',
  userId: '123456',
  documentType: TDocumentType.OTHER,
  documentName: 'Aadhar Card - Anjali Patel',
  submissionDate: '2023-10-18',
  verificationDate: '2023-10-20',
  status: TDocumentStatus.PENDING,
  remarks: 'Document submitted for verification',
  fileUrl: 'https://example.com/document',
  thumbnailUrl: 'https://example.com/thumbnail',
  description: 'Aadhar card document for identity verification',
  uploadedAt: mockUserAction,
};
